<template>
  <section>
    <h1 class="responsive">
      OS Allowed are
      <span class="os-allowed"> MacOs , Android , Linux </span>
    </h1>
  </section>
</template>
<script>
export default {
  name: 'StepsOS',
}
</script>
<style scoped>
.responsive {
  font-size: 3vh;
}
.os-allowed {
  color: rgb(103, 189, 103);
}
</style>
